(function() {

function waitForElement(selector, callback) {
  const el = document.querySelector(selector);
  if (el) return callback(el);

  const observer = new MutationObserver(() => {
    const el = document.querySelector(selector);
    if (el) {
      observer.disconnect();
      callback(el);
    }
  });

  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
}

function waitForShadowRoot(element, callback) {
  if (element.shadowRoot) return callback(element);

  const interval = setInterval(() => {
    if (element.shadowRoot) {
      clearInterval(interval);
      callback(element);
    }
  }, 100);
}

function init() {
  waitForElement('rubik-swatch', (rubik) => {
    waitForShadowRoot(rubik, () => {
      waitForElement('.ks-chart-container', (kiwi) => {
        console.log('[kiwi] injecting styles');

        const style = document.createElement('style');
        style.textContent = `
          .ks-chart-container {
            display:flex;
            cursor:pointer;
          }
          .ks-chart-container svg{
            width:20px;
            height:20px;
          }
        `;

        rubik.shadowRoot.appendChild(style);

        console.log('[kiwi] moving kiwi element to body');

        const originalKiwi = document.querySelector('.ks-chart-container');
        originalKiwi.style.display = 'none';
        document.body.appendChild(originalKiwi);

        // Adding a timeout for allowing kiwi style to be avialable
        setTimeout(() => {
          console.log('[kiwi] attaching event');
          document.addEventListener('rubik-variant-id-changed', () => {
            const rubik = document.querySelector('rubik-swatch');
            if (!rubik || !rubik.shadowRoot) return;

            const target = rubik.shadowRoot.querySelector(
              '.rubik-swatch__option:last-of-type > .rubik-swatch__option-name'
            );

            const kiwi = document.querySelector('.ks-chart-container');

            if (!target || !kiwi) return;

            if (target.querySelector('.ks-chart-container')) return;

            const clonedKiwi = kiwi.cloneNode(true);
            clonedKiwi.style.display = 'block';
            clonedKiwi.addEventListener('click', () => {
              kiwi.querySelector('span')?.click();
            });

            target.appendChild(clonedKiwi);
            console.log('[kiwi] variant changed');

          });

          console.log('[kiwi] dispatching rubik event on first load');        
          document.dispatchEvent(
            new CustomEvent('rubik-variant-id-changed')
          );          
        }, 10);
      });
    });
  });
}
init();

})();